import { useCallback, useEffect, useState } from 'react'
import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import { subscibeTo } from 'app/common/data-box-store'
import {
  defaultEmployeeListDataReceiver,
  defaultEmployeeListSelection,
  employeeListFilter,
  employeeListFilterSelection,
  customerTypeFilterSelection,
  orgsFilterSelection,
} from 'app/dataProviders/filter-items'
import { CustomerType } from 'app/common/ui-next/_filter-compilations/customer-search/types'

type Props = {
  id: string
  pending: boolean
}

export const EmployeeListFilter = ({ id, pending }: Props) => {
  const [isReadyCustomerType, setReadyCustomerType] = useState<boolean>(false)
  const [isReadyOrgs, setReadyOrgs] = useState<boolean>(false)

  const handleEmployeeFilter = useCallback(() => {
    employeeListFilter.addDataReceiver(defaultEmployeeListDataReceiver)
    employeeListFilter.dataReceive()
    employeeListFilter.setStatusReady()
  }, [])

  const handleOrgsFilter = useCallback((data: string[]) => {
    if (data.length === 1 && data[0] !== 'empty') {
      setReadyOrgs(true)
      return
    }
    employeeListFilter.resetToDefault()
    setReadyOrgs(false)
  }, [])

  const handleCustomerTypeFilter = useCallback((data: string[]) => {
    if (data.length === 1 && data[0] === CustomerType.Employee) {
      setReadyCustomerType(true)
      return
    }
    employeeListFilter.resetToDefault()
    setReadyCustomerType(false)
  }, [])

  useEffect(() => {
    const customerTypeFilterUnsubsribe = subscibeTo<string[]>(
      customerTypeFilterSelection.id,
      handleCustomerTypeFilter,
    )
    const orgsUnsubsribe = subscibeTo<string[]>(orgsFilterSelection.id, handleOrgsFilter)

    return () => {
      customerTypeFilterUnsubsribe()
      orgsUnsubsribe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (isReadyOrgs && isReadyCustomerType) {
      handleEmployeeFilter()
    }
  }, [handleEmployeeFilter, isReadyCustomerType, isReadyOrgs])

  return (
    isReadyCustomerType &&
    isReadyOrgs && (
      <PlainItemsSelectorBox
        id={id}
        label="Сотрудники"
        header="Выбор сотрудника"
        dataBoxData={employeeListFilter}
        dataBoxSelection={employeeListFilterSelection}
        pleaseSelectText="Нет данных"
        selectedAllOnEmptySelection
        defaultSelection={defaultEmployeeListSelection}
        disabled={pending}
      />
    )
  )
}
